
(function(){
  'use strict';
 
  function initLaxShotMap(){
    var root = document.getElementById('lax-shotmap-root');
    if(!root) return;
    if(root.dataset.mounted === '1') return;
    root.dataset.mounted = '1';
 
    var PREFIX = 'lax_' + Math.random().toString(36).slice(2,9);
 
    var customerId = (root.getAttribute('data-customer-id') || '').trim();
    var isMember = !!customerId;
    var storage = isMember ? window.localStorage : window.sessionStorage;
    var STORAGE_KEY = isMember ? ('lax_shotmap_pro_'+customerId+'_v7') : 'lax_shotmap_pro_guest_v7';
 
    var el = {
      field: root.querySelector('#lax_field'),
      goalWrap: root.querySelector('#lax_goalWrap'),
      goal: root.querySelector('#lax_goal'),
      stepIndicator: root.querySelector('#lax_stepIndicator'),
      goals: root.querySelector('#lax_goals'),
      shots: root.querySelector('#lax_shots'),
      sog: root.querySelector('#lax_sog'),
      pct: root.querySelector('#lax_pct'),
      roster: root.querySelector('#lax_roster'),
 
      addPlayer: root.querySelector('#lax_addPlayer'),
      bulkAdd: root.querySelector('#lax_bulkAdd'),
      resetRoster: root.querySelector('#lax_resetRoster'),
 
      gameSelect: root.querySelector('#lax_gameSelect'),
      goalieHand: root.querySelector('#lax_goalieHand'),
      playerSelect: root.querySelector('#lax_playerSelect'),
 
      toast: root.querySelector('#lax_toast'),
 
      picker: root.querySelector('#lax_picker'),
      pickerBackdrop: root.querySelector('#lax_pickerBackdrop'),
      pickerTitle: root.querySelector('#lax_pickerTitle'),
      pickerGrid: root.querySelector('#lax_pickerGrid'),
 
      newGame: root.querySelector('#lax_newGame'),
      export: root.querySelector('#lax_export'),
      summaryPdf: root.querySelector('#lax_summaryPdf'),
      undo: root.querySelector('#lax_undo'),
      loadDemo: root.querySelector('#lax_loadDemo'),
      help: root.querySelector('#lax_help'),
      tutorial: root.querySelector('#lax_tutorial'),
      tutorialBackdrop: root.querySelector('#lax_tutorialBackdrop'),
      tutorialClose: root.querySelector('#lax_tutorialClose'),
      tutorialDontShow: root.querySelector('#lax_tutorialDontShow'),
      rosterSetup: root.querySelector('#lax_rosterSetup'),
      rosterSetupBackdrop: root.querySelector('#lax_rosterSetupBackdrop'),
      bulkRoster: root.querySelector('#lax_bulkRoster'),
      rosterSkip: root.querySelector('#lax_rosterSkip'),
      rosterSave: root.querySelector('#lax_rosterSave'),
      rosterDontShow: root.querySelector('#lax_rosterDontShow'),
      liveMode: root.querySelector('#lax_liveMode'),
      liveBackdrop: root.querySelector('#lax_liveBackdrop'),
      liveModal: root.querySelector('#lax_liveModal'),
      liveTitle: root.querySelector('#lax_liveTitle'),
      liveClose: root.querySelector('#lax_liveClose'),
      liveStep1: root.querySelector('#lax_liveStep1'),
      liveStep2: root.querySelector('#lax_liveStep2'),
      liveStep3: root.querySelector('#lax_liveStep3'),
      liveField: root.querySelector('#lax_liveField'),
      liveGoal: root.querySelector('#lax_liveGoal'),
      livePlayer: root.querySelector('#lax_livePlayer'),
      liveBounce: root.querySelector('#lax_liveBounce'),
      liveSave: root.querySelector('#lax_liveSave'),
      commit: root.querySelector('#lax_commit'),
 
      leftHand: root.querySelector('#attr_leftHand'),
      rightHand: root.querySelector('#attr_rightHand'),
      overhand: root.querySelector('#attr_overhand'),
      sidearm: root.querySelector('#attr_sidearm'),
      underhand: root.querySelector('#attr_underhand'),
      quickstick: root.querySelector('#attr_quickstick'),
      goose: root.querySelector('#attr_goose'),
      btb: root.querySelector('#attr_btb'),
      bounce: root.querySelector('#attr_bounce'),
 
      stickStats: root.querySelector('#lax_stickStats'),
      attrStats: root.querySelector('#lax_attrStats'),
 
      playerMiniGrid: root.querySelector('#lax_playerMiniGrid')
    };
 
    function uid(){ return Math.random().toString(36).slice(2,10) + Date.now().toString(36).slice(2,6); }
    function todayLabel(){
      var d=new Date();
      var mm=String(d.getMonth()+1).padStart(2,'0');
      var dd=String(d.getDate()).padStart(2,'0');
      return mm+'/'+dd+'/'+d.getFullYear()+' vs Opponent';
    }
    function pct(m,a){ return a ? Math.round((m/a)*100) : 0; }
    function toast(msg){
      el.toast.textContent = msg;
      el.toast.classList.add('show');
      clearTimeout(toast._t);
      toast._t = setTimeout(function(){ el.toast.classList.remove('show'); }, 1600);
    }
    function escapeHtml(s){
      s = String(s);
      return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');
    }
 
    // ✅ ALL is view-only
    var ALL_PLAYER_ID = '__ALL__';
    var SEASON_VIEW_ID = '__SEASON__';
 
    // ✅ Proper patch: lives inside init (can access el + ALL_PLAYER_ID)
    function updateSaveButtonState(){
      var v = el.playerSelect.value;
      var isSeasonView = (state.currentGameId === SEASON_VIEW_ID);
      var disabled = (!v || v === ALL_PLAYER_ID || isSeasonView);
      el.commit.disabled = disabled;
      el.commit.classList.toggle('disabled', disabled);
      el.commit.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
 
    var state = {
      goalieHand: 'right',
      games: [],
      players: [],
      currentGameId: null,
      pendingShot: null,
      step: 'field'
    };
 
    // Demo season data for coaches
    var demoModeOn = false;
    var savedStateBeforeDemo = null;
 
    function toggleDemoMode(){
      if(demoModeOn){
        // Turn off demo mode - restore previous state
        if(savedStateBeforeDemo){
          state.players = savedStateBeforeDemo.players;
          state.games = savedStateBeforeDemo.games;
          state.currentGameId = savedStateBeforeDemo.currentGameId;
          state.goalieHand = savedStateBeforeDemo.goalieHand;
          savedStateBeforeDemo = null;
        }
        demoModeOn = false;
        el.loadDemo.textContent = 'Demo Off';
        el.loadDemo.style.background = 'rgba(100,100,100,.2)';
        el.loadDemo.style.borderColor = 'rgba(100,100,100,.3)';
        el.loadDemo.style.color = 'rgba(255,255,255,.5)';
        save(); // Save restored state
        renderAll();
        toast('Demo mode OFF');
      } else {
        // Turn on demo mode - save current state first
        savedStateBeforeDemo = {
          players: JSON.parse(JSON.stringify(state.players)),
          games: JSON.parse(JSON.stringify(state.games)),
          currentGameId: state.currentGameId,
          goalieHand: state.goalieHand
        };
        loadDemoSeason();
        demoModeOn = true;
        el.loadDemo.textContent = 'Demo On';
        el.loadDemo.style.background = 'rgba(59,130,246,.35)';
        el.loadDemo.style.borderColor = 'rgba(59,130,246,.5)';
        el.loadDemo.style.color = '#fff';
      }
    }
 
    function loadDemoSeason(){
      var demoPlayers = [
        {id: 'p1', name: 'Marcus'},
        {id: 'p2', name: 'Tyler'},
        {id: 'p3', name: 'Jake'},
        {id: 'p4', name: 'Chris'},
        {id: 'p5', name: 'Ryan'},
        {id: 'p6', name: 'Dylan'}
      ];
 
      var demoGames = [
        {id: 'g1', label: '03/15/2025 vs Westfield', shots: []},
        {id: 'g2', label: '03/22/2025 vs North Ridge', shots: []},
        {id: 'g3', label: '03/29/2025 vs Valley Central', shots: []},
        {id: 'g4', label: '04/05/2025 vs Eastbrook', shots: []},
        {id: 'g5', label: '04/12/2025 vs Summit Prep', shots: []},
        {id: 'g6', label: '04/19/2025 vs Riverside', shots: []}
      ];
 
      // Goal geometry - shots must stay within goal area (not below bottom)
      // Goal inner area: left:50, right:170, top:35, bottom:117
      var goalInner = {
        left: 52, right: 168, top: 37, bottom: 115
      };
 
      function randBetween(min, max){ return Math.random() * (max - min) + min; }
      function pickOne(arr){ return arr[Math.floor(Math.random() * arr.length)]; }
 
      // Shot patterns - corners and sides score higher
      var shotPatterns = [
        // Top corners - high scoring
        {zone: 'topLeft', gx: [52, 80], gy: [37, 55], goalProb: 0.45},
        {zone: 'topRight', gx: [140, 168], gy: [37, 55], goalProb: 0.45},
        // Top center - goalie sees it
        {zone: 'topCenter', gx: [85, 135], gy: [37, 55], goalProb: 0.20},
        // Side pockets - good scoring
        {zone: 'midLeft', gx: [52, 75], gy: [55, 90], goalProb: 0.40},
        {zone: 'midRight', gx: [145, 168], gy: [55, 90], goalProb: 0.40},
        // Mid center - goalie covers
        {zone: 'midCenter', gx: [85, 135], gy: [55, 90], goalProb: 0.18},
        // Low corners - five hole and sides
        {zone: 'lowLeft', gx: [52, 80], gy: [90, 115], goalProb: 0.42},
        {zone: 'lowRight', gx: [140, 168], gy: [90, 115], goalProb: 0.42},
        // Low center - five hole
        {zone: 'lowCenter', gx: [90, 130], gy: [95, 115], goalProb: 0.38}
      ];
 
      // Player tendencies (some players are better shooters)
      var playerTendencies = {
        'p1': {modifier: 1.3, prefHand: 'right', prefRelease: 'overhand'},   // Star player
        'p2': {modifier: 1.1, prefHand: 'right', prefRelease: 'sidearm'},
        'p3': {modifier: 0.9, prefHand: 'left', prefRelease: 'overhand'},
        'p4': {modifier: 1.0, prefHand: 'right', prefRelease: 'overhand'},
        'p5': {modifier: 1.2, prefHand: 'left', prefRelease: 'sidearm'},     // Lefty sniper
        'p6': {modifier: 0.85, prefHand: 'right', prefRelease: 'underhand'}  // Young player
      };
 
      function generateShot(gameIdx, playerId){
        var pattern = pickOne(shotPatterns);
        var tendency = playerTendencies[playerId] || {modifier: 1.0, prefHand: 'right', prefRelease: 'overhand'};
 
        // Field position - most shots from close to the goal (crease area)
        // Field Y: lower = closer to goal (goal is at top, Y ~18)
        // Most shots from Y 20-45 (close range)
        var distanceRoll = Math.random();
        var fieldY, fieldX;
 
        if(distanceRoll < 0.5){
          // Close range (high percentage)
          fieldY = randBetween(20, 35);
          fieldX = randBetween(30, 70);
        } else if(distanceRoll < 0.8){
          // Mid range
          fieldY = randBetween(35, 48);
          fieldX = randBetween(20, 80);
        } else {
          // Long range (lower percentage)
          fieldY = randBetween(48, 58);
          fieldX = randBetween(15, 85);
        }
 
        // Adjust goal probability based on distance
        var distanceMultiplier = 1.0;
        if(fieldY < 30) distanceMultiplier = 1.2; // Close = better
        else if(fieldY > 48) distanceMultiplier = 0.7; // Far = worse
 
        // Goal position - ensure it stays within goal bounds
        var goalX = randBetween(pattern.gx[0], pattern.gx[1]);
        var goalY = randBetween(pattern.gy[0], pattern.gy[1]);
 
        // Clamp to goal boundaries
        goalX = Math.max(goalInner.left, Math.min(goalInner.right, goalX));
        goalY = Math.max(goalInner.top, Math.min(goalInner.bottom, goalY));
 
        // Determine outcome
        var roll = Math.random();
        var adjustedProb = pattern.goalProb * tendency.modifier * distanceMultiplier;
        var outcome;
 
        if(roll < adjustedProb){
          outcome = 'goal';
        } else if(roll < adjustedProb + 0.28){
          outcome = 'saved';
        } else if(roll < adjustedProb + 0.38){
          // Pipe hit - adjust position to be on pipe
          var pipeChoice = Math.random();
          if(pipeChoice < 0.33){
            goalY = randBetween(30, 35); // Top pipe
            goalX = randBetween(50, 170);
          } else if(pipeChoice < 0.66){
            goalX = randBetween(45, 50); // Left pipe
            goalY = randBetween(35, 115);
          } else {
            goalX = randBetween(170, 175); // Right pipe
            goalY = randBetween(35, 115);
          }
          outcome = 'pipe';
        } else {
          // Miss - outside the goal but NOT below the goal
          var missDir = Math.random();
          if(missDir < 0.4){
            goalY = randBetween(5, 28); // High miss
            goalX = randBetween(30, 190);
          } else if(missDir < 0.7){
            goalX = randBetween(5, 43); // Wide left
            goalY = randBetween(20, 100);
          } else {
            goalX = randBetween(177, 210); // Wide right
            goalY = randBetween(20, 100);
          }
          outcome = 'miss';
        }
 
        // Attributes
        var hand = Math.random() < 0.7 ? tendency.prefHand : (tendency.prefHand === 'right' ? 'left' : 'right');
        var release = Math.random() < 0.6 ? tendency.prefRelease : pickOne(['overhand', 'sidearm', 'underhand']);
 
        var special = null;
        var specialRoll = Math.random();
        if(specialRoll < 0.08) special = 'quickstick';
        else if(specialRoll < 0.12) special = 'btb';
        else if(specialRoll < 0.15) special = 'goose';
 
        var bounce = Math.random() < 0.12;
 
        return {
          id: uid(),
          fieldX: fieldX,
          fieldY: fieldY,
          goalX: goalX,
          goalY: goalY,
          outcome: outcome,
          playerId: playerId,
          hand: hand,
          release: release,
          special: special,
          bounce: bounce
        };
      }
 
      // Generate shots for each game (12-16 shots per game is realistic)
      var shotsPerGame = [14, 12, 16, 13, 15, 14];
 
      for(var g=0; g<demoGames.length; g++){
        var numShots = shotsPerGame[g];
        for(var s=0; s<numShots; s++){
          var playerId = pickOne(demoPlayers).id;
          // Weight towards better players taking more shots
          if(Math.random() < 0.3) playerId = 'p1'; // Marcus takes more shots
          if(Math.random() < 0.15) playerId = 'p5'; // Ryan also featured
 
          demoGames[g].shots.push(generateShot(g, playerId));
        }
      }
 
      state.players = demoPlayers;
      state.games = demoGames;
      state.currentGameId = SEASON_VIEW_ID; // Start in season view
      state.goalieHand = 'right';
 
      // Don't save demo data to localStorage - keep it in memory only
      renderAll();
      toast('Demo season loaded!');
    }
 
    // Check if this is first load (no existing data)
    function shouldLoadDemo(){
      try{
        var raw = storage.getItem(STORAGE_KEY);
        return !raw;
      }catch(e){ return true; }
    }
 
    function save(){ try{ storage.setItem(STORAGE_KEY, JSON.stringify(state)); }catch(e){} }
    function load(){
      try{
        var raw = storage.getItem(STORAGE_KEY);
        if(!raw){
          // Initialize with empty default state
          state.games = [{ id: uid(), label: todayLabel(), shots: [] }];
          state.players = [
            {id: uid(), name: 'Player 1'},
            {id: uid(), name: 'Player 2'},
            {id: uid(), name: 'Player 3'},
            {id: uid(), name: 'Player 4'},
            {id: uid(), name: 'Player 5'}
          ];
          return;
        }
        var data = JSON.parse(raw);
        if(data && data.games && data.players){
          for(var k in data) state[k] = data[k];
          state.step = 'field';
          state.pendingShot = null;
          if(!state.goalieHand) state.goalieHand = 'right';
        }
      }catch(e){
        // Initialize with defaults on error
        state.games = [{ id: uid(), label: todayLabel(), shots: [] }];
        state.players = [
          {id: uid(), name: 'Player 1'},
          {id: uid(), name: 'Player 2'},
          {id: uid(), name: 'Player 3'},
          {id: uid(), name: 'Player 4'},
          {id: uid(), name: 'Player 5'}
        ];
      }
    }
    function currentGame(){
      for(var i=0;i<state.games.length;i++){
        if(state.games[i].id === state.currentGameId) return state.games[i];
      }
      return state.games[0];
    }
 
    // Get shots based on current view (single game or season)
    function getActiveShots(){
      if(state.currentGameId === SEASON_VIEW_ID){
        // Aggregate all shots from all games
        var allShots = [];
        for(var i=0;i<state.games.length;i++){
          allShots = allShots.concat(state.games[i].shots);
        }
        return allShots;
      }
      return currentGame().shots;
    }
 
    function isSeasonView(){
      return state.currentGameId === SEASON_VIEW_ID;
    }
 
    function shotColor(outcome){
      if(outcome==='goal') return '#37d67a';
      if(outcome==='saved') return '#ffd23f';
      if(outcome==='pipe') return '#ff6b35';
      return '#ff4d6d';
    }
    function isMake(s){ return s.outcome === 'goal'; }
 
    // Goal geometry constants (used for zone calculations)
    var GOAL_GEOM = {goalX:45, goalY:30, goalW:130, goalH:92, pipe:5};
 
    // Zone functions based on GOAL position (not field position)
    function goalZoneRow(goalY){
      var innerTop = GOAL_GEOM.goalY + GOAL_GEOM.pipe;
      var innerBottom = GOAL_GEOM.goalY + GOAL_GEOM.goalH - GOAL_GEOM.pipe;
      var innerHeight = innerBottom - innerTop;
      var third = innerHeight / 3;
 
      if(goalY == null) return null;
      if(goalY < innerTop + third) return 'Top';
      if(goalY < innerTop + 2 * third) return 'Mid';
      return 'Low';
    }
 
    function goalZoneCol(goalX){
      var innerLeft = GOAL_GEOM.goalX + GOAL_GEOM.pipe;
      var innerRight = GOAL_GEOM.goalX + GOAL_GEOM.goalW - GOAL_GEOM.pipe;
      var innerWidth = innerRight - innerLeft;
      var third = innerWidth / 3;
 
      if(goalX == null) return null;
      if(goalX < innerLeft + third) return 'Left';
      if(goalX < innerLeft + 2 * third) return 'Center';
      return 'Right';
    }
 
    function stickSideFromGoalX(goalX){
      // Stick side is based on where shot lands in goal, from shooter's perspective
      // Right-handed goalie: their stick is on shooter's LEFT (low goalX)
      // Left-handed goalie: their stick is on shooter's RIGHT (high goalX)
      var centerX = GOAL_GEOM.goalX + GOAL_GEOM.goalW / 2; // center of goal
      if(goalX == null) return null;
      if(state.goalieHand === 'right') {
        return (goalX < centerX) ? 'Stick Side' : 'Off-Stick';
      }
      return (goalX > centerX) ? 'Stick Side' : 'Off-Stick';
    }
 
    function drawApprovedFieldBase(svg){
      var NS='http://www.w3.org/2000/svg';
      svg.innerHTML = '';
      svg.setAttribute('viewBox','0 0 100 85');
      svg.setAttribute('preserveAspectRatio','xMidYMid slice');
 
      function S(tag, attrs){
        var n=document.createElementNS(NS, tag);
        for(var k in attrs) n.setAttribute(k, attrs[k]);
        return n;
      }
 
      var gradId = PREFIX + '_fieldGrad';
      var noiseId = PREFIX + '_turfNoise';
 
      var defs = S('defs',{});
      var grad = S('linearGradient',{id:gradId,x1:'0%',y1:'0%',x2:'0%',y2:'100%'});
      grad.innerHTML =
        '<stop offset="0%" style="stop-color:#148a55"/>' +
        '<stop offset="100%" style="stop-color:#0c6f44"/>';
      defs.appendChild(grad);
 
      var noise = S('filter',{id:noiseId,x:'-10%',y:'-10%',width:'120%',height:'120%'});
      noise.innerHTML =
        '<feTurbulence type="fractalNoise" baseFrequency="9.5" numOctaves="1" seed="17" result="noise"/>' +
        '<feColorMatrix type="matrix" values="' +
          '0 0 0 0 0.03 ' +
          '0 0 0 0 0.09 ' +
          '0 0 0 0 0.03 ' +
          '0 0 0 0.018 0"/>' +
        '<feBlend mode="multiply" in="SourceGraphic" in2="noise"/>';
      defs.appendChild(noise);
 
      svg.appendChild(defs);
      svg.appendChild(S('rect',{x:0,y:0,width:100,height:85,fill:'url(#'+gradId+')',filter:'url(#'+noiseId+')'}));
 
      var bottomLineY = 57.6;
      var lines = S('g',{stroke:'#ffffff','stroke-width':'0.7',fill:'none',opacity:'0.92'});
      lines.appendChild(S('rect',{x:2,y:2,width:96,height:81,rx:1.4}));
      lines.appendChild(S('line',{x1:2,y1:bottomLineY,x2:98,y2:bottomLineY}));
      lines.appendChild(S('line',{x1:20,y1:2,x2:20,y2:bottomLineY}));
      lines.appendChild(S('line',{x1:80,y1:2,x2:80,y2:bottomLineY}));
      svg.appendChild(lines);
 
      var scale = 0.64;
      var creaseCx=50, creaseCy=18, creaseR=9.5*scale;
 
      svg.appendChild(S('circle',{
        cx:creaseCx, cy:creaseCy, r:creaseR,
        fill:'rgba(255,255,255,0.055)',
        stroke:'#ffffff',
        'stroke-width':'0.65'
      }));
 
      var tipMargin = 2.6*scale;
      var triHeight = creaseR - tipMargin;
      var halfBase  = 4.1*scale;
 
      svg.appendChild(S('path',{
        d:'M '+creaseCx+' '+(creaseCy - triHeight)+' L '+(creaseCx - halfBase)+' '+creaseCy+' L '+(creaseCx + halfBase)+' '+creaseCy+' Z',
        fill:'#85cfa0',
        stroke:'#ff6b35',
        'stroke-width':'0.65',
        opacity:'0.95'
      }));
 
      // NOTE: no orange floating rectangle here anymore ✅
    }
 
    function drawField(){
      var svg = el.field;
      drawApprovedFieldBase(svg);
 
      var NS='http://www.w3.org/2000/svg';
      var shots = getActiveShots();
      var shotsG = document.createElementNS(NS,'g');
 
      var selectedId = el.playerSelect.value || '';
      var useAll = (!selectedId || selectedId === ALL_PLAYER_ID);
 
      // Smaller markers for season view (more shots)
      var markerSize = isSeasonView() ? 1.4 : 2.1;
      var strokeWidth = isSeasonView() ? 0.4 : 0.7;
 
      for(var i=0;i<shots.length;i++){
        var s = shots[i];
 
        // Filter by selected player
        if(!useAll && s.playerId !== selectedId) continue;
 
        var c = document.createElementNS(NS,'circle');
        c.setAttribute('cx', s.fieldX);
        c.setAttribute('cy', s.fieldY);
        c.setAttribute('r', markerSize);
        c.setAttribute('fill', shotColor(s.outcome));
        c.setAttribute('stroke', '#fff');
        c.setAttribute('stroke-width', strokeWidth);
        c.style.cursor = 'pointer';
        (function(id){
          c.addEventListener('click', function(ev){ ev.stopPropagation(); deleteShot(id); });
        })(s.id);
        shotsG.appendChild(c);
      }
 
      if(state.pendingShot && state.pendingShot.fieldX != null){
        var ring = document.createElementNS(NS,'circle');
        ring.setAttribute('cx', state.pendingShot.fieldX);
        ring.setAttribute('cy', state.pendingShot.fieldY);
        ring.setAttribute('r', '3.6');
        ring.setAttribute('fill', 'rgba(255,255,255,0.06)');
        ring.setAttribute('stroke', '#ffffff');
        ring.setAttribute('stroke-width', '0.8');
        shotsG.appendChild(ring);
 
        var dot = document.createElementNS(NS,'circle');
        dot.setAttribute('cx', state.pendingShot.fieldX);
        dot.setAttribute('cy', state.pendingShot.fieldY);
        dot.setAttribute('r', '2.2');
        dot.setAttribute('fill', '#ffffff');
        dot.setAttribute('opacity', '0.9');
        shotsG.appendChild(dot);
      }
 
      svg.appendChild(shotsG);
    }
 
    // GOAL: side pipes length = crossbar length (stop at goalH)
    function drawGoal(){
      var svg = el.goal;
      svg.innerHTML = '';
      svg.setAttribute('viewBox','0 0 220 170');
      svg.setAttribute('preserveAspectRatio','xMidYMid slice');
 
      var NS='http://www.w3.org/2000/svg';
      function S(tag, attrs){
        var n=document.createElementNS(NS, tag);
        for(var k in attrs) n.setAttribute(k, attrs[k]);
        return n;
      }
 
      svg.appendChild(S('rect',{x:0,y:0,width:220,height:170,fill:'#0f7f52'}));
      svg.appendChild(S('rect',{x:10,y:10,width:200,height:150,rx:10,fill:'rgba(255,255,255,0.05)'}));
 
      var goalX=GOAL_GEOM.goalX, goalY=GOAL_GEOM.goalY, goalW=GOAL_GEOM.goalW, goalH=GOAL_GEOM.goalH, pipe=GOAL_GEOM.pipe;
      drawGoal._geom = {goalX:goalX,goalY:goalY,goalW:goalW,goalH:goalH,pipe:pipe};
 
      svg.appendChild(S('rect',{
        x:goalX+pipe, y:goalY+pipe,
        width:goalW-2*pipe, height:goalH-2*pipe,
        rx:8,
        fill:'rgba(185,245,198,0.20)'
      }));
 
      svg.appendChild(S('rect',{x:goalX,y:goalY,width:goalW,height:pipe,rx:2,fill:'rgba(255,107,53,0.88)'}));
      svg.appendChild(S('rect',{x:goalX,y:goalY,width:pipe,height:goalH,rx:2,fill:'rgba(255,107,53,0.88)'}));
      svg.appendChild(S('rect',{x:goalX+goalW-pipe,y:goalY,width:pipe,height:goalH,rx:2,fill:'rgba(255,107,53,0.88)'}));
 
      var shots = getActiveShots();
      var shotsG = S('g',{});
 
      var selectedId = el.playerSelect.value || '';
      var useAll = (!selectedId || selectedId === ALL_PLAYER_ID);
 
      // Smaller markers for season view (more shots)
      var markerSize = isSeasonView() ? 2.8 : 4.2;
      var strokeWidth = isSeasonView() ? 1 : 2;
 
      for(var i=0;i<shots.length;i++){
        var s = shots[i];
        if(s.goalX == null) continue;
 
        // Filter by selected player
        if(!useAll && s.playerId !== selectedId) continue;
 
        shotsG.appendChild(S('circle',{cx:s.goalX,cy:s.goalY,r:markerSize,fill:shotColor(s.outcome),stroke:'#fff','stroke-width':strokeWidth}));
      }
 
      if(state.pendingShot && state.pendingShot.goalX != null){
        shotsG.appendChild(S('circle',{cx:state.pendingShot.goalX,cy:state.pendingShot.goalY,r:7,fill:'rgba(255,255,255,0.05)',stroke:'#fff','stroke-width':1}));
        shotsG.appendChild(S('circle',{cx:state.pendingShot.goalX,cy:state.pendingShot.goalY,r:4.2,fill:'#fff',opacity:'0.9'}));
      }
 
      svg.appendChild(shotsG);
    }
 
    function updateStepIndicator(){
      if(isSeasonView()){
        el.stepIndicator.textContent = '📊 SEASON VIEW – Aggregated stats from all games (view only)';
        return;
      }
      if(state.step === 'field'){
        el.stepIndicator.textContent = '1️⃣ Tap the FIELD where the shot was taken (marker appears immediately)';
      } else if(state.step === 'goal'){
        el.stepIndicator.textContent = '2️⃣ Tap SHOT LOCATION: inside goal (Goal/Saved), orange pipes (Pipe), outside (Miss)';
      } else {
        el.stepIndicator.textContent = '3️⃣ Select details + player, then ✓ SAVE SHOT';
      }
    }
 
    // Live Mode
    var liveModeOn = false;
    var livePendingShot = null;
 
    function showLiveModal(){
      liveModeOn = true;
      livePendingShot = {};
      root.classList.add('liveMode');
      el.liveBackdrop.classList.add('show');
      el.liveModal.classList.add('show');
      showLiveStep(1);
      drawLiveField();
      populateLivePlayerSelect();
      toast('🎯 Live Mode ON');
    }
 
    function hideLiveModal(){
      liveModeOn = false;
      livePendingShot = null;
      root.classList.remove('liveMode');
      el.liveBackdrop.classList.remove('show');
      el.liveModal.classList.remove('show');
      toast('Live Mode OFF');
    }
 
    function showLiveStep(step){
      el.liveStep1.style.display = (step === 1) ? 'block' : 'none';
      el.liveStep2.style.display = (step === 2) ? 'block' : 'none';
      el.liveStep3.style.display = (step === 3) ? 'block' : 'none';
 
      if(step === 1){
        el.liveTitle.textContent = '1️⃣ Field Position';
      } else if(step === 2){
        el.liveTitle.textContent = '2️⃣ Shot Location';
      } else {
        el.liveTitle.textContent = '3️⃣ Save Shot';
      }
    }
 
    function drawLiveField(){
      drawApprovedFieldBase(el.liveField);
 
      var NS='http://www.w3.org/2000/svg';
      var g = document.createElementNS(NS,'g');
 
      // Draw previous shots from current game
      var gameShots = currentGame().shots;
      for(var i=0; i<gameShots.length; i++){
        var s = gameShots[i];
        var c = document.createElementNS(NS,'circle');
        c.setAttribute('cx', s.fieldX);
        c.setAttribute('cy', s.fieldY);
        c.setAttribute('r', '2.1');
        c.setAttribute('fill', shotColor(s.outcome));
        c.setAttribute('stroke', '#fff');
        c.setAttribute('stroke-width', '0.7');
        c.setAttribute('opacity', '0.7');
        g.appendChild(c);
      }
 
      // Add pending marker if exists
      if(livePendingShot && livePendingShot.fieldX != null){
        var ring = document.createElementNS(NS,'circle');
        ring.setAttribute('cx', livePendingShot.fieldX);
        ring.setAttribute('cy', livePendingShot.fieldY);
        ring.setAttribute('r', '3.6');
        ring.setAttribute('fill', 'rgba(255,255,255,0.06)');
        ring.setAttribute('stroke', '#ffffff');
        ring.setAttribute('stroke-width', '0.8');
        g.appendChild(ring);
 
        var dot = document.createElementNS(NS,'circle');
        dot.setAttribute('cx', livePendingShot.fieldX);
        dot.setAttribute('cy', livePendingShot.fieldY);
        dot.setAttribute('r', '2.2');
        dot.setAttribute('fill', '#ffffff');
        dot.setAttribute('opacity', '0.9');
        g.appendChild(dot);
      }
 
      el.liveField.appendChild(g);
    }
 
    function drawLiveGoal(){
      var svg = el.liveGoal;
      while(svg.firstChild) svg.removeChild(svg.firstChild);
      svg.setAttribute('preserveAspectRatio','xMidYMid slice');
 
      var NS='http://www.w3.org/2000/svg';
      function S(tag, attrs){
        var e = document.createElementNS(NS, tag);
        for(var k in attrs) e.setAttribute(k, attrs[k]);
        return e;
      }
 
      var gx=GOAL_GEOM.goalX, gy=GOAL_GEOM.goalY, gw=GOAL_GEOM.goalW, gh=GOAL_GEOM.goalH, p=GOAL_GEOM.pipe;
 
      // Background
      svg.appendChild(S('rect',{x:0,y:0,width:220,height:170,fill:'#0f7f52'}));
 
      // Goal interior
      svg.appendChild(S('rect',{x:gx,y:gy,width:gw,height:gh,rx:4,fill:'#f0fdf4',stroke:'#16a34a','stroke-width':2}));
 
      // Zone grid
      var innerLeft=gx+p, innerRight=gx+gw-p, innerTop=gy+p, innerBottom=gy+gh-p;
      var colW=(innerRight-innerLeft)/3, rowH=(innerBottom-innerTop)/3;
      for(var i=1;i<3;i++){
        svg.appendChild(S('line',{x1:innerLeft+i*colW,y1:innerTop,x2:innerLeft+i*colW,y2:innerBottom,stroke:'#16a34a','stroke-width':1,'stroke-dasharray':'6,4',opacity:.5}));
        svg.appendChild(S('line',{x1:innerLeft,y1:innerTop+i*rowH,x2:innerRight,y2:innerTop+i*rowH,stroke:'#16a34a','stroke-width':1,'stroke-dasharray':'6,4',opacity:.5}));
      }
 
      // Pipes
      svg.appendChild(S('rect',{x:gx,y:gy,width:gw,height:p,rx:2,fill:'#f97316'}));
      svg.appendChild(S('rect',{x:gx,y:gy,width:p,height:gh,rx:2,fill:'#f97316'}));
      svg.appendChild(S('rect',{x:gx+gw-p,y:gy,width:p,height:gh,rx:2,fill:'#f97316'}));
 
      // Draw previous shots from current game
      var gameShots = currentGame().shots;
      for(var i=0; i<gameShots.length; i++){
        var s = gameShots[i];
        if(s.goalX == null) continue;
        var c = S('circle',{cx:s.goalX,cy:s.goalY,r:4.2,fill:shotColor(s.outcome),stroke:'#fff','stroke-width':1.5,opacity:0.6});
        svg.appendChild(c);
      }
 
      // Pending marker if exists
      if(livePendingShot && livePendingShot.goalX != null){
        var c = S('circle',{cx:livePendingShot.goalX,cy:livePendingShot.goalY,r:6,fill:shotColor(livePendingShot.outcome),stroke:'#fff','stroke-width':2});
        svg.appendChild(c);
      }
    }
 
    function populateLivePlayerSelect(){
      el.livePlayer.innerHTML = '';
      for(var i=0;i<state.players.length;i++){
        var p = state.players[i];
        var opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.name;
        el.livePlayer.appendChild(opt);
      }
    }
 
    function resetLiveAttrs(){
      var btns = el.liveModal.querySelectorAll('.liveAttrBtn');
      for(var i=0;i<btns.length;i++){
        btns[i].classList.remove('active');
      }
      el.liveBounce.checked = false;
    }
 
    // Live Field click
    el.liveField.addEventListener('click', function(e){
      if(!liveModeOn) return;
      if(isSeasonView()){ toast('Switch to a game to add shots'); return; }
 
      var rect = el.liveField.getBoundingClientRect();
      var scaleX = 100 / rect.width;
      var scaleY = 85 / rect.height;
      var x = (e.clientX - rect.left) * scaleX;
      var y = (e.clientY - rect.top) * scaleY;
 
      livePendingShot.fieldX = x;
      livePendingShot.fieldY = y;
 
      drawLiveField();
      drawLiveGoal();
      showLiveStep(2);
    });
 
    // Live Goal click
    el.liveGoal.addEventListener('click', handleLiveGoalClick);
 
    function openLiveOutcomePicker(){
      // Replace step 2 content with goal/saved buttons
      el.liveStep2.innerHTML = '' +
        '<div class="liveHint">Was it a Goal or Saved?</div>' +
        '<div class="liveOutcomeBtns">' +
          '<button class="liveOutcomeBtn goal" id="lax_liveGoalBtn">⚡ GOAL</button>' +
          '<button class="liveOutcomeBtn saved" id="lax_liveSavedBtn">🧤 SAVED</button>' +
        '</div>';
 
      document.getElementById('lax_liveGoalBtn').addEventListener('click', function(){
        livePendingShot.outcome = 'goal';
        toast('Goal!');
        restoreLiveStep2();
        drawLiveGoal();
        resetLiveAttrs();
        showLiveStep(3);
      });
 
      document.getElementById('lax_liveSavedBtn').addEventListener('click', function(){
        livePendingShot.outcome = 'saved';
        toast('Saved');
        restoreLiveStep2();
        drawLiveGoal();
        resetLiveAttrs();
        showLiveStep(3);
      });
    }
 
    function restoreLiveStep2(){
      el.liveStep2.innerHTML = '' +
        '<div class="liveHint">Tap shot result: inside goal, pipes, or miss</div>' +
        '<div class="liveGoalWrap">' +
          '<svg id="lax_liveGoal" viewBox="0 0 220 170"></svg>' +
        '</div>';
      el.liveGoal = root.querySelector('#lax_liveGoal');
      // Re-attach listener
      el.liveGoal.addEventListener('click', handleLiveGoalClick);
      // Redraw the goal
      drawLiveGoal();
    }
 
    function handleLiveGoalClick(e){
      if(!liveModeOn || !livePendingShot || livePendingShot.fieldX == null) return;
 
      var rect = el.liveGoal.getBoundingClientRect();
      var scaleX = 220 / rect.width;
      var scaleY = 170 / rect.height;
      var x = (e.clientX - rect.left) * scaleX;
      var y = (e.clientY - rect.top) * scaleY;
 
      var gx=GOAL_GEOM.goalX, gy=GOAL_GEOM.goalY, gw=GOAL_GEOM.goalW, gh=GOAL_GEOM.goalH, p=GOAL_GEOM.pipe;
 
      // Reject clicks below the goal plane (bottom of goal)
      if(y > gy + gh){
        toast('Tap above the goal line');
        return;
      }
 
      var inGoal = (x >= gx+p && x <= gx+gw-p && y >= gy+p && y <= gy+gh-p);
      var inPipe =
        (x >= gx && x <= gx+gw && y >= gy && y <= gy+p) ||
        (x >= gx && x <= gx+p && y >= gy && y <= gy+gh) ||
        (x >= gx+gw-p && x <= gx+gw && y >= gy && y <= gy+gh);
 
      livePendingShot.goalX = x;
      livePendingShot.goalY = y;
 
      if(inPipe){
        livePendingShot.outcome = 'pipe';
        toast('Pipe');
        drawLiveGoal();
        resetLiveAttrs();
        showLiveStep(3);
        return;
      }
 
      if(inGoal){
        openLiveOutcomePicker();
        return;
      }
 
      livePendingShot.outcome = 'miss';
      toast('Miss');
      drawLiveGoal();
      resetLiveAttrs();
      showLiveStep(3);
    }
 
    // Live attr buttons
    el.liveModal.addEventListener('click', function(e){
      if(!e.target.classList.contains('liveAttrBtn')) return;
      var attr = e.target.dataset.attr;
      var val = e.target.dataset.val;
 
      // Toggle within same group
      var btns = el.liveModal.querySelectorAll('.liveAttrBtn[data-attr="'+attr+'"]');
      for(var i=0;i<btns.length;i++){
        btns[i].classList.remove('active');
      }
      e.target.classList.add('active');
 
      livePendingShot[attr] = val;
    });
 
    // Live Save
    el.liveSave.addEventListener('click', function(){
      if(!liveModeOn || !livePendingShot || livePendingShot.goalX == null) return;
      if(isSeasonView()){ toast('Switch to a game to save'); return; }
 
      var playerId = el.livePlayer.value;
      if(!playerId){ toast('Select a player'); return; }
 
      var shot = {
        id: uid(),
        fieldX: livePendingShot.fieldX,
        fieldY: livePendingShot.fieldY,
        goalX: livePendingShot.goalX,
        goalY: livePendingShot.goalY,
        outcome: livePendingShot.outcome,
        playerId: playerId,
        hand: livePendingShot.hand || null,
        release: livePendingShot.release || null,
        special: livePendingShot.special || null,
        bounce: el.liveBounce.checked
      };
 
      currentGame().shots.push(shot);
      save();
 
      var outcomeText = shot.outcome.charAt(0).toUpperCase() + shot.outcome.slice(1);
      toast('✓ ' + outcomeText + ' saved!');
 
      // Reset for next shot
      livePendingShot = {};
      resetLiveAttrs();
      showLiveStep(1);
      drawLiveField();
 
      // Update main view in background
      renderAll();
    });
 
    function toggleLiveMode(){
      if(liveModeOn){
        hideLiveModal();
      } else {
        if(isSeasonView()){
          toast('Switch to a game to use Live Mode');
          return;
        }
        showLiveModal();
      }
    }
 
    function renderStats(){
      var shots = getActiveShots();
      var selectedId = el.playerSelect.value || '';
      var useAll = (!selectedId || selectedId === ALL_PLAYER_ID);
 
      var goals=0, saved=0, totalShots=0;
      for(var i=0;i<shots.length;i++){
        var s = shots[i];
 
        // Filter by selected player
        if(!useAll && s.playerId !== selectedId) continue;
 
        totalShots++;
        var o = s.outcome;
        if(o==='goal') goals++;
        else if(o==='saved') saved++;
      }
      var sog = goals + saved;
      el.goals.textContent = goals;
      el.shots.textContent = totalShots;
      el.sog.textContent = pct(sog, totalShots) + '%';
      el.pct.textContent = pct(goals, totalShots) + '%';
    }
 
    function renderGameSelect(){
      el.gameSelect.innerHTML = '';
 
      // Add Season (All Games) option at top
      var seasonOpt = document.createElement('option');
      seasonOpt.value = SEASON_VIEW_ID;
      seasonOpt.textContent = '📊 Season (All Games)';
      el.gameSelect.appendChild(seasonOpt);
 
      // Add separator
      var sep = document.createElement('option');
      sep.disabled = true;
      sep.textContent = '────────────';
      el.gameSelect.appendChild(sep);
 
      for(var i=0;i<state.games.length;i++){
        var gm = state.games[i];
        var opt = document.createElement('option');
        opt.value = gm.id;
        opt.textContent = gm.label;
        el.gameSelect.appendChild(opt);
      }
      el.gameSelect.value = state.currentGameId;
    }
 
    // ✅ Player select (preserve selection)
    function renderPlayerSelect(){
      var prev = el.playerSelect.value || '';
      el.playerSelect.innerHTML = '';
 
      var optBlank = document.createElement('option');
      optBlank.value = '';
      optBlank.textContent = '-- Select Player --';
      el.playerSelect.appendChild(optBlank);
 
      var optAll = document.createElement('option');
      optAll.value = ALL_PLAYER_ID;
      optAll.textContent = 'All (view only)';
      el.playerSelect.appendChild(optAll);
 
      for(var i=0;i<state.players.length;i++){
        var p = state.players[i];
        var opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.name;
        el.playerSelect.appendChild(opt);
      }
 
      el.playerSelect.value = prev;
      if(el.playerSelect.value !== prev) el.playerSelect.value = '';
    }
 
    function renderRoster(){
      el.roster.innerHTML = '';
      var shots = getActiveShots();
      var statsBy = {};
      for(var i=0;i<state.players.length;i++){
        statsBy[state.players[i].id] = {name: state.players[i].name, goals:0, attempts:0};
      }
      for(var j=0;j<shots.length;j++){
        var s=shots[j];
        if(statsBy[s.playerId]){
          statsBy[s.playerId].attempts++;
          if(s.outcome==='goal') statsBy[s.playerId].goals++;
        }
      }
 
      for(var k=0;k<state.players.length;k++){
        var pl = state.players[k];
        var st = statsBy[pl.id] || {name:pl.name,goals:0,attempts:0};
        var row = document.createElement('div');
        row.className='player';
        row.innerHTML =
          '<div class="meta">' +
            '<div class="name">'+escapeHtml(st.name)+'</div>' +
            '<div class="sub">'+st.goals+'G / '+st.attempts+'A • '+pct(st.goals, st.attempts)+'%</div>' +
          '</div>' +
          '<div class="actions">' +
            '<button class="primary" data-act="rename" data-id="'+pl.id+'">Edit</button>' +
            '<button class="danger" data-act="remove" data-id="'+pl.id+'">Del</button>' +
          '</div>';
        el.roster.appendChild(row);
      }
 
      var btns = el.roster.querySelectorAll('button[data-act]');
      for(var b=0;b<btns.length;b++){
        btns[b].addEventListener('click', function(ev){
          ev.stopPropagation();
          var id = this.getAttribute('data-id');
          var act = this.getAttribute('data-act');
          if(act==='rename') renamePlayer(id);
          if(act==='remove') removePlayer(id);
        });
      }
    }
 
    function renderZoneStats(){
      var shots = getActiveShots();
      var selectedId = el.playerSelect.value || '';
      var useAll = (!selectedId || selectedId === ALL_PLAYER_ID);
 
      var stick = {'Stick Side':{m:0,a:0}, 'Off-Stick':{m:0,a:0}};
      var hand = {left:{m:0,a:0}, right:{m:0,a:0}, none:{m:0,a:0}};
      var release = {overhand:{m:0,a:0}, sidearm:{m:0,a:0}, underhand:{m:0,a:0}, none:{m:0,a:0}};
      var special = {quickstick:{m:0,a:0}, goose:{m:0,a:0}, btb:{m:0,a:0}, none:{m:0,a:0}};
      var bounce = {bounce:{m:0,a:0}, nobounce:{m:0,a:0}};
 
      for(var s=0;s<shots.length;s++){
        var sh = shots[s];
 
        // Filter by selected player
        if(!useAll && sh.playerId !== selectedId) continue;
 
        var ss = stickSideFromGoalX(sh.goalX);
        if(ss) { stick[ss].a++; if(isMake(sh)) stick[ss].m++; }
 
        var h = sh.hand || 'none';
        hand[h].a++; if(isMake(sh)) hand[h].m++;
 
        var rel = sh.release || 'none';
        release[rel].a++; if(isMake(sh)) release[rel].m++;
 
        var sp = sh.special || 'none';
        special[sp].a++; if(isMake(sh)) special[sp].m++;
 
        var bb = sh.bounce ? 'bounce' : 'nobounce';
        bounce[bb].a++; if(isMake(sh)) bounce[bb].m++;
      }
 
      var stickHtml = '<tr><th>Side</th><th class="right">G / Att</th></tr>';
      var keys=['Stick Side','Off-Stick'];
      for(var kk=0;kk<keys.length;kk++){
        var key=keys[kk];
        var v=stick[key];
        stickHtml += '<tr><td>'+key+'</td><td class="right">'+v.m+'/'+v.a+' <span class="muted">('+pct(v.m,v.a)+'%)</span></td></tr>';
      }
      el.stickStats.innerHTML = stickHtml;
 
      function rowLine(label, v){
        return '<tr><td>'+label+'</td><td class="right">'+v.m+'/'+v.a+' <span class="muted">('+pct(v.m,v.a)+'%)</span></td></tr>';
      }
      var attrHtml = '<tr><th>Attribute</th><th class="right">G / Att</th></tr>';
      attrHtml += '<tr><td colspan="2" class="muted" style="background:rgba(255,255,255,.03);font-weight:950;">Hand</td></tr>';
      attrHtml += rowLine('Left', hand.left) + rowLine('Right', hand.right) + rowLine('None', hand.none);
      attrHtml += '<tr><td colspan="2" class="muted" style="background:rgba(255,255,255,.03);font-weight:950;">Release</td></tr>';
      attrHtml += rowLine('Overhand', release.overhand) + rowLine('Sidearm', release.sidearm) + rowLine('Underhand', release.underhand) + rowLine('None', release.none);
      attrHtml += '<tr><td colspan="2" class="muted" style="background:rgba(255,255,255,.03);font-weight:950;">Special</td></tr>';
      attrHtml += rowLine('Quickstick', special.quickstick) + rowLine('Goose', special.goose) + rowLine('BTB', special.btb) + rowLine('None', special.none);
      attrHtml += '<tr><td colspan="2" class="muted" style="background:rgba(255,255,255,.03);font-weight:950;">Bounce</td></tr>';
      attrHtml += rowLine('Bounce', bounce.bounce) + rowLine('No bounce', bounce.nobounce);
      el.attrStats.innerHTML = attrHtml;
    }
 
    function renderPlayerMiniGrid(){
      if(!el.playerMiniGrid) return;
 
      var selectedId = el.playerSelect.value || '';
      var shots = getActiveShots();
 
      if(!selectedId){
        el.playerMiniGrid.innerHTML =
          '<div class="muted" style="font-size:12px;padding:8px 0;">Select a player (or All) to see the mini heat grid.</div>';
        return;
      }
 
      var rows = ['Top','Mid','Low'];
      var cols = ['Left','Center','Right'];
 
      var grid = {};
      for(var r=0;r<rows.length;r++){
        grid[rows[r]] = {};
        for(var c=0;c<cols.length;c++){
          grid[rows[r]][cols[c]] = {m:0,a:0};
        }
      }
 
      var useAll = (selectedId === ALL_PLAYER_ID);
 
      for(var i=0;i<shots.length;i++){
        var sh = shots[i];
        if(!useAll && sh.playerId !== selectedId) continue;
 
        // Only include shots inside the goal (goals and saves)
        if(sh.outcome !== 'goal' && sh.outcome !== 'saved') continue;
 
        // Skip shots without goal coordinates (shouldn't happen, but safe)
        if(sh.goalX == null || sh.goalY == null) continue;
 
        // Use GOAL position for zone calculation
        var rr = goalZoneRow(sh.goalY);
        var cc = goalZoneCol(sh.goalX);
 
        if(rr && cc){
          grid[rr][cc].a++;
          if(sh.outcome === 'goal') grid[rr][cc].m++;
        }
      }
 
      function cellBg(m,a){
        if(!a) return 'rgba(255,255,255,0.03)';
        var p = m / a;
        var green = Math.round(55 + (160 * p));
        var red   = Math.round(160 - (120 * p));
        return 'rgba('+red+','+green+',90,0.28)';
      }
 
      var name = 'All';
      if(!useAll){
        name = 'Player';
        for(var p=0;p<state.players.length;p++){
          if(state.players[p].id === selectedId){ name = state.players[p].name; break; }
        }
      }
 
      var html = '';
      html += '<div class="muted" style="font-size:12px;margin-bottom:8px;">'+escapeHtml(name)+' – Shots on goal only (goals + saves)</div>';
      html += '<div class="miniGrid">';
      html += '<div></div>';
      html += '<div class="hdr">Left</div><div class="hdr">Center</div><div class="hdr">Right</div>';
 
      for(var r2=0;r2<rows.length;r2++){
        var row = rows[r2];
        html += '<div class="rowHdr">'+row+'</div>';
        for(var c2=0;c2<cols.length;c2++){
          var col = cols[c2];
          var v = grid[row][col];
          var misses = v.a - v.m;
          html += ''
            + '<div class="cell" style="background:'+cellBg(v.m,v.a)+'">'
            +   '<div class="big">'+v.m+'/'+v.a+' <span class="muted">('+pct(v.m,v.a)+'%)</span></div>'
            +   '<div class="small">'+v.m+' goals</div>'
            + '</div>';
        }
      }
      html += '</div>';
 
      el.playerMiniGrid.innerHTML = html;
    }
 
    function renderAll(){
      if(!state.currentGameId) state.currentGameId = state.games[0].id;
      el.goalieHand.value = state.goalieHand || 'right';
 
      drawField();
      drawGoal();
      updateStepIndicator();
      renderStats();
      renderRoster();
      renderGameSelect();
      renderPlayerSelect();
      renderZoneStats();
      renderPlayerMiniGrid();
      updateSaveButtonState();
      save();
    }
 
    function svgPointFromClient(clientX, clientY, svgEl, vbW, vbH){
      var r = svgEl.getBoundingClientRect();
      var x = ((clientX - r.left) / r.width) * vbW;
      var y = ((clientY - r.top) / r.height) * vbH;
      x = Math.max(0, Math.min(vbW, x));
      y = Math.max(0, Math.min(vbH, y));
      return {x:x,y:y};
    }
 
    el.field.addEventListener('click', function(e){
      if(isSeasonView()){ toast('Switch to a game to add shots'); return; }
      if(state.step !== 'field') return;
 
      var pt = svgPointFromClient(e.clientX, e.clientY, el.field, 100, 85);
 
      state.pendingShot = {
        id: uid(),
        fieldX: pt.x,
        fieldY: pt.y,
        goalX: null,
        goalY: null,
        outcome: null,
        playerId: null,
        hand: null,
        release: null,
        special: null,
        bounce: false
      };
 
      state.step = 'goal';
      toast('✓ Field position recorded');
      renderAll();
    });
 
    el.goal.addEventListener('click', function(e){
      if(state.step !== 'goal' || !state.pendingShot) return;
 
      var pt = svgPointFromClient(e.clientX, e.clientY, el.goal, 220, 170);
 
      var geom = drawGoal._geom || GOAL_GEOM;
      var gx=geom.goalX, gy=geom.goalY, gw=geom.goalW, gh=geom.goalH, p=geom.pipe;
 
      // Reject clicks below the goal plane (bottom of goal)
      if(pt.y > gy + gh){
        toast('Tap above the goal line');
        return;
      }
 
      state.pendingShot.goalX = pt.x;
      state.pendingShot.goalY = pt.y;
 
      var inGoal = (pt.x >= gx+p && pt.x <= gx+gw-p && pt.y >= gy+p && pt.y <= gy+gh-p);
      var inPipe =
        (pt.x >= gx && pt.x <= gx+gw && pt.y >= gy && pt.y <= gy+p) ||
        (pt.x >= gx && pt.x <= gx+p && pt.y >= gy && pt.y <= gy+gh) ||
        (pt.x >= gx+gw-p && pt.x <= gx+gw && pt.y >= gy && pt.y <= gy+gh);
 
      if(inPipe){
        state.pendingShot.outcome = 'pipe';
        toast('Pipe');
        state.step = 'attributes';
        renderAll();
        return;
      }
 
      if(inGoal){
        openOutcomePicker();
        renderAll();
        return;
      }
 
      state.pendingShot.outcome = 'miss';
      toast('Miss');
      state.step = 'attributes';
      renderAll();
    });
 
    function openOutcomePicker(){
      el.pickerTitle.textContent = 'Shot Result';
      el.pickerGrid.innerHTML = '';
 
      var goalBtn = document.createElement('button');
      goalBtn.className = 'pickBtn';
      goalBtn.type = 'button';
      goalBtn.textContent = '⚡ GOAL';
      goalBtn.addEventListener('click', function(){ setOutcome('goal'); });
 
      var savedBtn = document.createElement('button');
      savedBtn.className = 'pickBtn';
      savedBtn.type = 'button';
      savedBtn.textContent = '🧤 Saved';
      savedBtn.addEventListener('click', function(){ setOutcome('saved'); });
 
      el.pickerGrid.appendChild(goalBtn);
      el.pickerGrid.appendChild(savedBtn);
 
el.picker.style.position = 'fixed';
el.picker.style.left = '50%';
el.picker.style.top = '50%';
el.picker.style.transform = 'translate(-50%, -50%)';
el.picker.style.zIndex = '99999';
 
      el.picker.classList.add('show');
      el.pickerBackdrop.style.display = 'block';
el.pickerBackdrop.style.position = 'fixed';
el.pickerBackdrop.style.zIndex = '99998';
    }
 
    function closePicker(){
      el.picker.classList.remove('show');
      el.pickerBackdrop.style.display = 'none';
    }
 
    function setOutcome(outcome){
      if(!state.pendingShot) return;
      state.pendingShot.outcome = outcome;
      closePicker();
      state.step = 'attributes';
      toast(outcome === 'goal' ? '⚡ GOAL!' : '🧤 Saved');
      renderAll();
    }
 
    el.pickerBackdrop.addEventListener('click', closePicker);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') closePicker();
    });
 
    function clearAttrButtons(group){
      var buttons = {
        hand: [el.leftHand, el.rightHand],
        release: [el.overhand, el.sidearm, el.underhand],
        special: [el.quickstick, el.goose, el.btb]
      };
      var arr = buttons[group] || [];
      for(var i=0;i<arr.length;i++) arr[i].classList.remove('selected');
    }
 
    el.leftHand.addEventListener('click', function(){ clearAttrButtons('hand'); el.leftHand.classList.add('selected'); });
    el.rightHand.addEventListener('click', function(){ clearAttrButtons('hand'); el.rightHand.classList.add('selected'); });
    el.overhand.addEventListener('click', function(){ clearAttrButtons('release'); el.overhand.classList.add('selected'); });
    el.sidearm.addEventListener('click', function(){ clearAttrButtons('release'); el.sidearm.classList.add('selected'); });
    el.underhand.addEventListener('click', function(){ clearAttrButtons('release'); el.underhand.classList.add('selected'); });
    el.quickstick.addEventListener('click', function(){ clearAttrButtons('special'); el.quickstick.classList.add('selected'); });
    el.goose.addEventListener('click', function(){ clearAttrButtons('special'); el.goose.classList.add('selected'); });
    el.btb.addEventListener('click', function(){ clearAttrButtons('special'); el.btb.classList.add('selected'); });
 
    el.commit.addEventListener('click', function(){
      if(!state.pendingShot){ toast('⚠️ Tap the field first'); return; }
      if(!state.pendingShot.outcome){ toast('⚠️ Tap shot location'); return; }
 
      var playerId = el.playerSelect.value;
      if(!playerId){ toast('⚠️ Select a player'); return; }
 
      // ✅ HARD BLOCK: All is view only
      if(playerId === ALL_PLAYER_ID){
        toast('All is view-only. Select a player to save.');
        updateSaveButtonState();
        return;
      }
 
      state.pendingShot.playerId = playerId;
 
      state.pendingShot.hand =
        el.leftHand.classList.contains('selected') ? 'left' :
        (el.rightHand.classList.contains('selected') ? 'right' : null);
 
      state.pendingShot.release =
        el.overhand.classList.contains('selected') ? 'overhand' :
        (el.sidearm.classList.contains('selected') ? 'sidearm' :
        (el.underhand.classList.contains('selected') ? 'underhand' : null));
 
      state.pendingShot.special =
        el.quickstick.classList.contains('selected') ? 'quickstick' :
        (el.goose.classList.contains('selected') ? 'goose' :
        (el.btb.classList.contains('selected') ? 'btb' : null));
 
      state.pendingShot.bounce = !!el.bounce.checked;
 
      currentGame().shots.push(state.pendingShot);
 
      state.pendingShot = null;
      state.step = 'field';
      clearAttrButtons('hand'); clearAttrButtons('release'); clearAttrButtons('special');
      el.bounce.checked = false;
 
      toast('✓ Shot saved!');
      renderAll();
    });
 
    function deleteShot(shotId){
      if(!confirm('Delete this shot?')) return;
 
      // Search all games for the shot (needed for season view)
      for(var i=0;i<state.games.length;i++){
        var gm = state.games[i];
        var origLen = gm.shots.length;
        gm.shots = gm.shots.filter(function(s){ return s.id !== shotId; });
        if(gm.shots.length < origLen){
          toast('Shot deleted');
          renderAll();
          return;
        }
      }
    }
 
    function undo(){
      var g = currentGame();
 
      if(state.step === 'attributes' && state.pendingShot){
        state.step = 'goal';
        state.pendingShot.outcome = null;
        state.pendingShot.goalX = null;
        state.pendingShot.goalY = null;
        toast('Back to shot location');
        renderAll();
        return;
      }
      if(state.step === 'goal' && state.pendingShot){
        state.pendingShot = null;
        state.step = 'field';
        toast('Cleared pending shot');
        renderAll();
        return;
      }
 
      if(g.shots.length === 0){ toast('No shots to undo'); return; }
      g.shots.pop();
      toast('✓ Shot removed');
      renderAll();
    }
 
    function newGame(){
      var label = prompt('Game label:', todayLabel());
      if(!label) return;
      var gm = { id: uid(), label: label, shots: [] };
      state.games.unshift(gm);
      state.currentGameId = gm.id;
      state.pendingShot = null;
      state.step = 'field';
      toast('New game created');
      renderAll();
    }
 
    function exportData(){
      var data = {
        exportDate: new Date().toISOString(),
        goalieHand: state.goalieHand,
        games: state.games,
        players: state.players
      };
      var json = JSON.stringify(data, null, 2);
      var blob = new Blob([json], {type: 'application/json'});
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'lacrosse_shotmap_pro_'+new Date().toISOString().split('T')[0]+'.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast('✓ Export complete!');
    }
 
    // ✅ Summary PDF export (opens print dialog; user saves as PDF)
    function exportSummaryPdf(){
      var isSeason = isSeasonView();
      var shots = getActiveShots();
      var selectedId = el.playerSelect.value || '';
      var useAllPlayers = (!selectedId || selectedId === ALL_PLAYER_ID);
 
      // Get player name for title
      var playerName = 'All Players';
      if(!useAllPlayers){
        for(var p=0;p<state.players.length;p++){
          if(state.players[p].id === selectedId){ 
            playerName = state.players[p].name; 
            break; 
          }
        }
      }
 
      // Filter shots by selected player
      var filteredShots = shots.filter(function(s){
        return useAllPlayers || s.playerId === selectedId;
      });
 
      // totals
      var goals=0, saved=0, pipe=0, miss=0;
      filteredShots.forEach(function(s){
        if(s.outcome==='goal') goals++;
        else if(s.outcome==='saved') saved++;
        else if(s.outcome==='pipe') pipe++;
        else miss++;
      });
 
      var totalShots = filteredShots.length;
      var sog = goals + saved; // pipe excluded from SOG
      var sogPct = pct(sog, totalShots);
      var shotPct = pct(goals, totalShots);
 
      // stick side + attributes (goals vs non-goals)
      var stick = {'Stick Side':{m:0,a:0}, 'Off-Stick':{m:0,a:0}};
      var hand = {left:{m:0,a:0}, right:{m:0,a:0}, none:{m:0,a:0}};
      var release = {overhand:{m:0,a:0}, sidearm:{m:0,a:0}, underhand:{m:0,a:0}, none:{m:0,a:0}};
      var special = {quickstick:{m:0,a:0}, goose:{m:0,a:0}, btb:{m:0,a:0}, none:{m:0,a:0}};
      var bounce = {bounce:{m:0,a:0}, nobounce:{m:0,a:0}};
 
      filteredShots.forEach(function(s){
        var ss = stickSideFromGoalX(s.goalX);
        if(ss) { stick[ss].a++; if(s.outcome==='goal') stick[ss].m++; }
 
        var h = s.hand || 'none';
        hand[h].a++; if(s.outcome==='goal') hand[h].m++;
 
        var r = s.release || 'none';
        release[r].a++; if(s.outcome==='goal') release[r].m++;
 
        var sp = s.special || 'none';
        special[sp].a++; if(s.outcome==='goal') special[sp].m++;
 
        var bb = s.bounce ? 'bounce' : 'nobounce';
        bounce[bb].a++; if(s.outcome==='goal') bounce[bb].m++;
      });
 
      function mm(v){ return v.m + '/' + v.a + ' (' + pct(v.m, v.a) + '%)'; }
 
      // All shots zone mini grid (now based on GOAL position)
      var rows = ['Top','Mid','Low'];
      var cols = ['Left','Center','Right'];
      var grid = {};
      rows.forEach(function(r){
        grid[r] = {};
        cols.forEach(function(c){ grid[r][c] = {m:0,a:0}; });
      });
 
      filteredShots.forEach(function(s){
        // Only include shots inside the goal (goals and saves)
        if(s.outcome !== 'goal' && s.outcome !== 'saved') return;
        if(s.goalX == null || s.goalY == null) return;
        var rr = goalZoneRow(s.goalY);
        var cc = goalZoneCol(s.goalX);
        if(rr && cc){
          grid[rr][cc].a++;
          if(s.outcome === 'goal') grid[rr][cc].m++;
        }
      });
 
      function gridTableHtml(){
        var h = '<table class="t"><tr><th></th><th class="r">Left</th><th class="r">Center</th><th class="r">Right</th></tr>';
        rows.forEach(function(r){
          h += '<tr><th>'+r+'</th>';
          cols.forEach(function(c){
            var v = grid[r][c];
            h += '<td class="r">'+v.m+'/'+v.a+' <span class="muted">('+pct(v.m,v.a)+'%)</span></td>';
          });
          h += '</tr>';
        });
        h += '</table>';
        return h;
      }
 
      // roster summary (only show if All Players selected)
      var byPlayer = {};
      state.players.forEach(function(p){ byPlayer[p.id] = {name:p.name, g:0, a:0}; });
      shots.forEach(function(s){
        if(!s.playerId || !byPlayer[s.playerId]) return;
        byPlayer[s.playerId].a++;
        if(s.outcome==='goal') byPlayer[s.playerId].g++;
      });
 
      var rosterRows = '';
      state.players.forEach(function(p){
        var st = byPlayer[p.id] || {name:p.name,g:0,a:0};
        rosterRows += '<tr><td>'+escapeHtml(st.name)+'</td><td class="r">'+st.g+'</td><td class="r">'+st.a+'</td><td class="r">'+pct(st.g,st.a)+'%</td></tr>';
      });
 
      // Game-by-game breakdown for season view
      var gameBreakdownHtml = '';
      if(isSeason && useAllPlayers){
        gameBreakdownHtml = '<div class="card"><div class="h">Game-by-Game</div><table class="t"><tr><th>Game</th><th class="r">G</th><th class="r">S</th><th class="r">%</th></tr>';
        state.games.forEach(function(gm){
          var gg=0, gs=0;
          gm.shots.forEach(function(s){
            gs++;
            if(s.outcome==='goal') gg++;
          });
          gameBreakdownHtml += '<tr><td>'+escapeHtml(gm.label)+'</td><td class="r">'+gg+'</td><td class="r">'+gs+'</td><td class="r">'+pct(gg,gs)+'%</td></tr>';
        });
        gameBreakdownHtml += '</table></div>';
      }
 
      // Build shot chart SVG
      function buildShotChartSvg(){
        var gx=45, gy=20, gw=130, gh=92, p=5;
        var svgW=220, svgH=130;
 
        var svg = '<svg viewBox="0 0 '+svgW+' '+svgH+'" style="width:100%;max-width:320px;height:auto;display:block;margin:0 auto;">';
 
        // Goal frame
        svg += '<rect x="'+gx+'" y="'+gy+'" width="'+gw+'" height="'+gh+'" rx="4" fill="#f0fdf4" stroke="#16a34a" stroke-width="2"/>';
 
        // Pipes
        svg += '<rect x="'+gx+'" y="'+gy+'" width="'+gw+'" height="'+p+'" rx="2" fill="#f97316"/>';
        svg += '<rect x="'+gx+'" y="'+gy+'" width="'+p+'" height="'+gh+'" rx="2" fill="#f97316"/>';
        svg += '<rect x="'+(gx+gw-p)+'" y="'+gy+'" width="'+p+'" height="'+gh+'" rx="2" fill="#f97316"/>';
 
        // Zone grid lines (dashed)
        var innerLeft = gx + p;
        var innerRight = gx + gw - p;
        var innerTop = gy + p;
        var innerBottom = gy + gh - p;
        var colW = (innerRight - innerLeft) / 3;
        var rowH = (innerBottom - innerTop) / 3;
 
        svg += '<line x1="'+(innerLeft+colW)+'" y1="'+innerTop+'" x2="'+(innerLeft+colW)+'" y2="'+innerBottom+'" stroke="#d1d5db" stroke-width="1" stroke-dasharray="4,3"/>';
        svg += '<line x1="'+(innerLeft+2*colW)+'" y1="'+innerTop+'" x2="'+(innerLeft+2*colW)+'" y2="'+innerBottom+'" stroke="#d1d5db" stroke-width="1" stroke-dasharray="4,3"/>';
        svg += '<line x1="'+innerLeft+'" y1="'+(innerTop+rowH)+'" x2="'+innerRight+'" y2="'+(innerTop+rowH)+'" stroke="#d1d5db" stroke-width="1" stroke-dasharray="4,3"/>';
        svg += '<line x1="'+innerLeft+'" y1="'+(innerTop+2*rowH)+'" x2="'+innerRight+'" y2="'+(innerTop+2*rowH)+'" stroke="#d1d5db" stroke-width="1" stroke-dasharray="4,3"/>';
 
        // Shots - scale from original goal coords to this SVG (filtered)
        var origGx=45, origGy=30, origGw=130, origGh=92;
        filteredShots.forEach(function(s){
          if(s.goalX == null || s.goalY == null) return;
          // Scale coordinates
          var sx = gx + ((s.goalX - origGx) / origGw) * gw;
          var sy = gy + ((s.goalY - origGy) / origGh) * gh;
 
          var color = '#ff4d6d'; // miss
          if(s.outcome === 'goal') color = '#22c55e';
          else if(s.outcome === 'saved') color = '#facc15';
          else if(s.outcome === 'pipe') color = '#f97316';
 
          svg += '<circle cx="'+sx.toFixed(1)+'" cy="'+sy.toFixed(1)+'" r="'+(isSeason ? '4' : '5')+'" fill="'+color+'" stroke="#fff" stroke-width="1" opacity="0.85"/>';
        });
 
        svg += '</svg>';
        return svg;
      }
 
      // printable HTML
      var viewLabel = isSeason ? 'Season Summary' : escapeHtml(currentGame().label);
      var title = isSeason 
        ? (useAllPlayers ? 'Season Summary – All Players' : 'Season Summary – ' + escapeHtml(playerName))
        : (useAllPlayers ? 'Game Summary' : escapeHtml(playerName) + ' – Game Summary');
 
      var gamesCount = isSeason ? ' • ' + state.games.length + ' games' : '';
 
      var html =
'<!doctype html><html><head><meta charset="utf-8">' +
'<meta name="viewport" content="width=device-width,initial-scale=1">' +
'<title>'+title+'</title>' +
'<style>' +
'body{font-family:system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial;margin:12px 16px;color:#0b0f14;font-size:11px;line-height:1.3;}' +
'h1{margin:0;font-size:16px;font-weight:900;display:inline;}' +
'.header{display:flex;justify-content:space-between;align-items:center;margin-bottom:8px;padding-bottom:6px;border-bottom:2px solid '+(isSeason ? '#3b82f6' : '#e5e7eb')+';}' +
'.meta{font-size:10px;color:#6b7280;text-align:right;}' +
'.kpis{display:flex;gap:6px;margin-bottom:8px;}' +
'.kpi{flex:1;background:#f9fafb;border-radius:6px;padding:5px 6px;text-align:center;}' +
'.kpi .l{font-size:8px;color:#6b7280;text-transform:uppercase;letter-spacing:.2px;}' +
'.kpi .v{font-size:16px;font-weight:900;color:#111;}' +
'.row{display:flex;gap:8px;margin-bottom:8px;}' +
'.col{flex:1;min-width:0;}' +
'.col2{flex:2;}' +
'.card{border:1px solid #e5e7eb;border-radius:6px;padding:6px 8px;height:100%;box-sizing:border-box;}' +
'.h{margin:0 0 4px 0;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.3px;color:#6b7280;border-bottom:1px solid #f3f4f6;padding-bottom:3px;}' +
'.t{width:100%;border-collapse:collapse;font-size:10px;}' +
'.t th,.t td{padding:2px 4px;text-align:left;}' +
'.t th{font-weight:700;color:#374151;background:#f9fafb;}' +
'.t .r{text-align:right;}' +
'.muted{color:#9ca3af;font-size:9px;}' +
'.shot-chart{text-align:center;}' +
'.shot-chart svg{max-height:100px;}' +
'.legend{display:flex;gap:8px;justify-content:center;margin-top:4px;font-size:9px;color:#6b7280;}' +
'.legend span{display:flex;align-items:center;gap:3px;}' +
'.dot{width:8px;height:8px;border-radius:50%;}' +
'.season-badge{display:inline-block;background:#3b82f6;color:#fff;font-size:9px;padding:2px 6px;border-radius:4px;margin-left:8px;font-weight:700;}' +
'@media print{body{margin:8px 12px;}}' +
'</style></head><body>' +
 
'<div class="header">' +
  '<h1>'+title+(isSeason ? '<span class="season-badge">SEASON</span>' : '')+'</h1>' +
  '<div class="meta">'+(isSeason ? state.games.length + ' games' : viewLabel)+'<br>'+new Date().toLocaleDateString()+'</div>' +
'</div>' +
 
'<div class="kpis">' +
  '<div class="kpi"><div class="l">Goals</div><div class="v">'+goals+'</div></div>' +
  '<div class="kpi"><div class="l">Shots</div><div class="v">'+totalShots+'</div></div>' +
  '<div class="kpi"><div class="l">SOG%</div><div class="v">'+sogPct+'%</div></div>' +
  '<div class="kpi"><div class="l">Shot%</div><div class="v">'+shotPct+'%</div></div>' +
  '<div class="kpi"><div class="l">Saved</div><div class="v">'+saved+'</div></div>' +
  '<div class="kpi"><div class="l">Pipe</div><div class="v">'+pipe+'</div></div>' +
  '<div class="kpi"><div class="l">Miss</div><div class="v">'+miss+'</div></div>' +
'</div>' +
 
'<div class="row">' +
  '<div class="col">' +
    '<div class="card shot-chart">' +
      '<div class="h">Shot Chart</div>' + 
      buildShotChartSvg() + 
      '<div class="legend">' +
        '<span><span class="dot" style="background:#22c55e"></span>Goal</span>' +
        '<span><span class="dot" style="background:#facc15"></span>Save</span>' +
        '<span><span class="dot" style="background:#f97316"></span>Pipe</span>' +
        '<span><span class="dot" style="background:#ff4d6d"></span>Miss</span>' +
      '</div>' +
    '</div>' +
  '</div>' +
  '<div class="col">' +
    '<div class="card">' +
      '<div class="h">Goal Zones <span class="muted">(Goals + Saves only)</span></div>' + 
      gridTableHtml() + 
    '</div>' +
  '</div>' +
  '<div class="col">' +
    '<div class="card">' +
      '<div class="h">Stick Side</div>' +
      '<table class="t">' +
        '<tr><td>Stick Side</td><td class="r">'+mm(stick["Stick Side"])+'</td></tr>' +
        '<tr><td>Off-Stick</td><td class="r">'+mm(stick["Off-Stick"])+'</td></tr>' +
      '</table>' +
      '<div class="h" style="margin-top:8px;">Hand</div>' +
      '<table class="t">' +
        '<tr><td>Left</td><td class="r">'+mm(hand.left)+'</td></tr>' +
        '<tr><td>Right</td><td class="r">'+mm(hand.right)+'</td></tr>' +
        (hand.none.a > 0 ? '<tr><td class="muted">None</td><td class="r muted">'+mm(hand.none)+'</td></tr>' : '') +
      '</table>' +
    '</div>' +
  '</div>' +
'</div>' +
 
'<div class="row">' +
  '<div class="col">' +
    '<div class="card">' +
      '<div class="h">Release Type</div>' +
      '<table class="t">' +
        '<tr><td>Overhand</td><td class="r">'+mm(release.overhand)+'</td></tr>' +
        '<tr><td>Sidearm</td><td class="r">'+mm(release.sidearm)+'</td></tr>' +
        '<tr><td>Underhand</td><td class="r">'+mm(release.underhand)+'</td></tr>' +
        (release.none.a > 0 ? '<tr><td class="muted">None</td><td class="r muted">'+mm(release.none)+'</td></tr>' : '') +
      '</table>' +
    '</div>' +
  '</div>' +
  '<div class="col">' +
    '<div class="card">' +
      '<div class="h">Special Shots</div>' +
      '<table class="t">' +
        '<tr><td>Quickstick</td><td class="r">'+mm(special.quickstick)+'</td></tr>' +
        '<tr><td>Goose</td><td class="r">'+mm(special.goose)+'</td></tr>' +
        '<tr><td>BTB</td><td class="r">'+mm(special.btb)+'</td></tr>' +
        '<tr><td>Bounce</td><td class="r">'+mm(bounce.bounce)+'</td></tr>' +
      '</table>' +
    '</div>' +
  '</div>' +
  '<div class="col col2">' +
    (useAllPlayers ? 
    '<div class="card">' +
      '<div class="h">Roster Summary</div>' +
      '<table class="t">' +
        '<tr><th>Player</th><th class="r">G</th><th class="r">S</th><th class="r">%</th></tr>' +
        rosterRows +
      '</table>' +
    '</div>' : '') +
  '</div>' +
'</div>' +
 
(gameBreakdownHtml ? '<div class="row"><div class="col">'+gameBreakdownHtml+'</div></div>' : '') +
 
'</body></html>';
 
      var w = window.open('', '_blank');
      if(!w){ toast('Popup blocked — allow popups to export PDF.'); return; }
      w.document.open();
      w.document.write(html);
      w.document.close();
 
      w.focus();
      setTimeout(function(){ w.print(); }, 250);
    }
 
    function addPlayer(){
      var name = prompt('Player name:');
      if(!name) return;
      state.players.push({id: uid(), name: name.trim()});
      toast('Player added');
      renderAll();
    }
    function renamePlayer(id){
      var p = state.players.find(function(x){ return x.id===id; });
      if(!p) return;
      var name = prompt('Rename player:', p.name);
      if(!name) return;
      p.name = name.trim();
      toast('Player updated');
      renderAll();
    }
    function removePlayer(id){
      var p = state.players.find(function(x){ return x.id===id; });
      if(!p) return;
      if(!confirm('Remove '+p.name+'? Shots will remain but may show unassigned.')) return;
 
      state.players = state.players.filter(function(x){ return x.id !== id; });
 
      state.games.forEach(function(gm){
        gm.shots.forEach(function(s){
          if(s.playerId === id) s.playerId = null;
        });
      });
 
      toast('Player removed');
      renderAll();
    }
    function resetRoster(){
      if(!confirm('Reset roster to Player 1-5?')) return;
      state.players = [];
      for(var n=1;n<=5;n++) state.players.push({id: uid(), name:'Player '+n});
      toast('Roster reset');
      renderAll();
    }
 
    el.newGame.addEventListener('click', newGame);
    el.export.addEventListener('click', exportData);
    el.summaryPdf.addEventListener('click', exportSummaryPdf);
    el.undo.addEventListener('click', undo);
    el.loadDemo.addEventListener('click', toggleDemoMode);
 
    // Tutorial functions
    var TUTORIAL_KEY = isMember ? ('lax_tutorial_seen_'+customerId) : 'lax_tutorial_seen_guest';
    var ROSTER_SETUP_KEY = isMember ? ('lax_roster_setup_'+customerId) : 'lax_roster_setup_guest';
 
    function showTutorial(){
      el.tutorial.classList.add('show');
      el.tutorialBackdrop.classList.add('show');
    }
 
    function hideTutorial(){
      el.tutorial.classList.remove('show');
      el.tutorialBackdrop.classList.remove('show');
 
      if(el.tutorialDontShow.checked){
        try{ storage.setItem(TUTORIAL_KEY, '1'); }catch(e){}
      }
 
      // Show roster setup after tutorial if roster is default
      if(shouldShowRosterSetup()){
        setTimeout(function(){ showRosterSetup(true); }, 300);
      }
    }
 
    function shouldShowTutorial(){
      try{
        return !storage.getItem(TUTORIAL_KEY);
      }catch(e){ return true; }
    }
 
    function shouldShowRosterSetup(){
      try{
        if(storage.getItem(ROSTER_SETUP_KEY)) return false;
        // Check if roster is still default (Player 1, Player 2, etc)
        var isDefault = state.players.length === 5 && 
          state.players.every(function(p, i){ return p.name === 'Player '+(i+1); });
        return isDefault;
      }catch(e){ return false; }
    }
 
    function showRosterSetup(forceShow){
      if(!forceShow && !shouldShowRosterSetup()) return;
      el.rosterSetup.classList.add('show');
      el.rosterSetupBackdrop.classList.add('show');
      el.bulkRoster.value = '';
      el.rosterDontShow.checked = false;
      el.bulkRoster.focus();
    }
 
    function hideRosterSetup(){
      el.rosterSetup.classList.remove('show');
      el.rosterSetupBackdrop.classList.remove('show');
 
      // Only permanently dismiss if checkbox is checked
      if(el.rosterDontShow.checked){
        try{ storage.setItem(ROSTER_SETUP_KEY, '1'); }catch(e){}
      }
    }
 
    function saveBulkRoster(){
      var text = el.bulkRoster.value.trim();
      if(!text){
        toast('Enter at least one player name');
        return;
      }
 
      // Parse names - split by newlines or commas
      var names = text.split(/[\n,]+/)
        .map(function(n){ return n.trim(); })
        .filter(function(n){ return n.length > 0; });
 
      if(names.length === 0){
        toast('Enter at least one player name');
        return;
      }
 
      // Check if current roster is default
      var isDefault = state.players.length === 5 && 
        state.players.every(function(p, i){ return p.name === 'Player '+(i+1); });
 
      if(isDefault){
        // Replace default roster with new names
        state.players = names.map(function(name, i){
          return { id: 'p'+(i+1), name: name };
        });
      } else {
        // Add to existing roster
        var maxId = 0;
        state.players.forEach(function(p){
          var num = parseInt(p.id.replace('p',''), 10);
          if(num > maxId) maxId = num;
        });
 
        names.forEach(function(name){
          maxId++;
          state.players.push({ id: 'p'+maxId, name: name });
        });
      }
 
      save();
      renderRoster();
      renderPlayerSelect();
      hideRosterSetup();
      toast('✓ Added ' + names.length + ' player' + (names.length > 1 ? 's' : ''));
    }
 
    el.help.addEventListener('click', showTutorial);
    el.tutorialClose.addEventListener('click', hideTutorial);
    el.tutorialBackdrop.addEventListener('click', hideTutorial);
 
    el.rosterSkip.addEventListener('click', hideRosterSetup);
    el.rosterSave.addEventListener('click', saveBulkRoster);
    el.rosterSetupBackdrop.addEventListener('click', hideRosterSetup);
 
    // Live Mode event listeners
    el.liveMode.addEventListener('click', toggleLiveMode);
    el.liveClose.addEventListener('click', hideLiveModal);
    el.liveBackdrop.addEventListener('click', hideLiveModal);
 
    // Show tutorial on first visit, or roster setup if tutorial was already seen
    if(shouldShowTutorial()){
      setTimeout(showTutorial, 500);
    } else if(shouldShowRosterSetup()){
      // Tutorial was already seen but roster is still default
      setTimeout(function(){ showRosterSetup(true); }, 500);
    }
 
    el.addPlayer.addEventListener('click', addPlayer);
    el.bulkAdd.addEventListener('click', function(){ showRosterSetup(true); });
    el.resetRoster.addEventListener('click', resetRoster);
 
    el.gameSelect.addEventListener('change', function(){
      state.currentGameId = el.gameSelect.value;
      state.pendingShot = null;
      state.step = 'field';
      closePicker();
 
      if(isSeasonView()){
        toast('📊 Season View – All games');
      }
 
      renderAll();
    });
 
    el.goalieHand.addEventListener('change', function(){
      state.goalieHand = el.goalieHand.value;
      toast('Goalie: ' + (state.goalieHand==='right' ? 'Right-handed' : 'Left-handed'));
      renderAll();
    });
 
    el.playerSelect.addEventListener('change', function(){
      // Re-render everything when player selection changes
      drawField();
      drawGoal();
      renderStats();
      renderZoneStats();
      renderPlayerMiniGrid();
      updateSaveButtonState();
    });
 
    load();
    renderAll();
  }
 
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ setTimeout(initLaxShotMap, 60); });
  } else {
    setTimeout(initLaxShotMap, 60);
  }
  document.addEventListener('shopify:section:load', function(){ setTimeout(initLaxShotMap, 60); });
 
})();
